exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notification-collapse-narrow {\n  max-width: 120px;\n  min-width: 60px;\n}\n.notification-collapse-narrow .task-exp {\n  padding: 5px 10px;\n}\n.notification-count {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #495057;\n  white-space: nowrap;\n}\n.notification-close-text {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #495057;\n  white-space: nowrap;\n  margin-right: 5px;\n}\n.notification-collapse-narrow .icon img {\n  width: 12px;\n  height: 12px;\n}\n", ""]);

// exports
